import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import ApiService from "../../../network/ApiService";
import MemberDetail from "./MemberDetail";
import "./Team.css";

function Member() {
  const { fetchStaffs } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const [memberList, setMemberList] = useState([]);
    const languageStatus = sessionStorage.getItem("language");

  const getCommitteeMembersList = async () => {
    try {
      const res = await fetchStaffs();
      console.log("checking from members",res);
      setMemberList(res.data.committee);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (organizationId) {
      getCommitteeMembersList();
    }
  }, [organizationId]);
  return (
    <>

      <div className="tm-page">
        <div className="uk-section uk-section-default">
            <div className="uk-container">
             <ul uk-tab="animation: uk-animation-fade" className="uk-flex-center">
  {memberList.length > 0 &&
    memberList.map((item, index) => (
      <li key={index}>
        <a href="#">
          {languageStatus === "en" ? item.name : item.nameNp}
        </a>
      </li>
    ))}
</ul>


                <ul className="uk-switcher uk-margin-large">
                  {memberList.length > 0
                      ? memberList.map((data, key) => {
                        return (
                            <div key={key}>
                                <MemberDetail subHeaderItems={data} language={languageStatus} />
                            </div>
                        );
                      })
                      : null}
                </ul>
            </div>
        </div>
      </div>
    </>
  );
}

export default Member;
